let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '移动端管理'
},
{
    type: 'title',
    name: '通知管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'noticeDetail',
};

// 路由
pageConfig.listRouter = 'noticeList';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '移动端管理',
},
{
    type: 'router',
    name: '通知管理',
    router: 'noticeList'
},
{
    type: 'title',
    name: '通知详情',
},
];

pageConfig.formRules = {
    bannerMessage: [{
        required: true,
        message: '请填写通知内容',
        trigger: 'blur'
    }],
    bannerUrl: [{
        required: true,
        message: '请填写通知跳转地址',
        trigger: 'blur'
    }],
    affiliationType: [{
        required: true,
        message: '请选择所属移动端',
        trigger: 'change'
    }],
};



export default pageConfig;